import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BellRing, AlarmClock, Timer as TimerIcon } from "lucide-react";
import { useAlerts } from "@/context/AlertsContext";
import { useApp } from "@/context/AppContext";

const ICONS = { reminder: BellRing, alarm: AlarmClock, timer: TimerIcon };

export const RingingOverlay = () => {
  const { ringing, stopRinging, snooze } = useAlerts();
  const { t } = useApp();
  const canSnooze = ringing && ringing.kind !== "timer";

  return (
    <AnimatePresence>
      {ringing && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          data-testid="ringing-overlay"
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="w-full max-w-sm rounded-3xl border border-border bg-card p-8 text-center shadow-2xl"
          >
            <motion.div
              animate={{ scale: [1, 1.12, 1] }}
              transition={{ repeat: Infinity, duration: 0.9 }}
              className="mx-auto w-20 h-20 rounded-2xl bg-primary/15 flex items-center justify-center mb-5"
            >
              {(() => {
                const Icon = ICONS[ringing.kind] || BellRing;
                return <Icon className="w-10 h-10 text-primary" />;
              })()}
            </motion.div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
              {t(ringing.title)}
            </p>
            {ringing.subtitle && (
              <h2 className="font-heading text-2xl font-bold mt-2 break-words">{ringing.subtitle}</h2>
            )}
            <div className="mt-6 flex gap-3">
              {canSnooze && (
                <button
                  data-testid="ring-snooze-btn"
                  onClick={() => snooze(5)}
                  className="flex-1 h-12 rounded-xl bg-secondary text-foreground font-semibold hover:bg-accent active:scale-[0.98] transition-all"
                >
                  {t("snooze")}
                </button>
              )}
              <button
                data-testid="ring-dismiss-btn"
                onClick={stopRinging}
                className="flex-1 h-12 rounded-xl bg-primary text-primary-foreground font-semibold hover:brightness-110 active:scale-[0.98] transition-all"
              >
                {t("dismiss")}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
